import ReactDialpad from './components/dialpad/index';
import './styles/main.scss';

export default ReactDialpad;
